import { gql } from "@apollo/client";

export const PARTNER_LIST_QUERY = gql`
  query partners($pager: PagerInput!, $filters: PartnerFiltersInput!) {
    partners(pager: $pager, filters: $filters) {
      total
      values {
        id
        logoUrl
        partnerName
        uniqueId
        partnerTypeName
        location
        representatives
        phoneNumber
        e_mail
        isPJ
        isPF
      }
    }
  }
`;

export const PARTNER_TYPES_QUERY = gql`
  query partnerTypes {
    partnerTypes {
      partnerTypeId
      partnerTypeName
      partnerTypeCode
    }
  }
`;

export const PARTNER_SYNCHRONIZATION_STATUS_QUERY = gql`
  query synchronizationStatus($partnerId: Int!) {
    synchronizationStatus(partnerId: $partnerId)
  }
`;
